import {
  UpdateAvaiablePoint,
  MountedOrderCofirmButtonElement,
  InvokeSubmitOrderCofirmForm,
  UpdateOrderCofirmButtonElement,
  MountedInputPoint,
  InvokeCheckedInput,
} from "./types";
import $ from "jquery";

/**
 * 保持ポイントと「カートと数量変更含めた商品合計金額」+「お届け予定の商品合計金額」－「数量変更の削除分の商品合計金額」を比較し、ご利用可能ポイントを更新する
 * @param existsElement 要素の存在確認を行う関数
 * @param getInputValue 要素の値を更新する関数
 * @param setTextToElement 指定した要素のテキストを書き換える関数
 * @param formattedPrice 3桁区切りでカンマを付与した価格を返す関数
 * @param selector 指定した要素
 * @param availablePointSelector 利用可能ポイント要素
 */
export const updateAvaiablePoint: UpdateAvaiablePoint = (
  existsElement,
  getInputValue,
  setTextToElement,
  formattedPrice,
  selector,
  availablePointSelector
) => (additionalAmount, fixedAmount, deletedAmount) => {
  if (!existsElement(selector)) return;
  const totalPoint = getInputValue(selector);
  const totalAmount = additionalAmount + fixedAmount - deletedAmount;
  const point =
    totalAmount >= totalPoint ? parseInt(`${totalPoint}`, 10) : totalAmount;
  setTextToElement(
    availablePointSelector,
    point > 0 ? formattedPrice(point) : "0"
  );
};

/**
 * 要素の存在確認をし、存在した場合イベントハンドラを登録する
 * @param existsElement 要素の存在確認を行う関数
 * @param addEvent 要素にイベントをバインドする関数
 * @param invokeSubmitOrderCofirmForm フォーム送信処理
 * @param selector 指定した要素
 */
export const mountedOrderCofirmButtonElement: MountedOrderCofirmButtonElement = (
  existsElement,
  addEvent,
  invokeSubmitOrderCofirmForm,
  selector
) => () => {
  if (!existsElement(selector)) return;
  addEvent(selector, "click", invokeSubmitOrderCofirmForm);
};

/**
 * 要素の存在確認をし、存在した場合フォームを送信する
 * @param existsElement 要素の存在確認を行う関数
 * @param formSelector 送信対象のフォームセレクタ
 */
export const invokeSubmitOrderCofirmForm: InvokeSubmitOrderCofirmForm = (
  existsElement,
  formSelector
) => () => {
  if (!existsElement(formSelector)) return;
  $(formSelector).submit();
};

/**
 * 要素の存在確認をし、存在した場合要素のテキストを変更し、クラスを切り替える
 * @param existsElement 要素の存在確認を行う関数
 * @param setTextToElement 指定した要素のテキストを書き換える関数
 * @param addElementClass 要素からクラスを付与する関数
 * @param removeElementClass 要素からクラスを削除する関数
 * @param selector 指定した要素
 * @param toggleClassName 切り替えるクラス名
 */
export const updateOrderCofirmButtonElement: UpdateOrderCofirmButtonElement = (
  existsElement,
  setTextToElement,
  addElementClass,
  removeElementClass,
  selector,
  toggleClassName
) => (text, isConfirmed) => {
  if (existsElement(selector)) {
    setTextToElement(selector, text);
    isConfirmed
      ? addElementClass(selector, toggleClassName)
      : removeElementClass(selector, toggleClassName);
  }
};

/**
 * 要素の存在確認をし、存在した場合イベントハンドラを登録する
 * @param existsElement 要素の存在確認を行う関数
 * @param addEvent 要素にイベントをバインドする関数
 * @param invokeCheckedInput 入力要素の更新処理
 * @param selector 指定した要素
 */
export const mountedInputPoint: MountedInputPoint = (
  existsElement,
  addEvent,
  invokeCheckedInput,
  selector
) => () => {
  if (!existsElement(selector)) return;
  addEvent(selector, "change", invokeCheckedInput);
};

/**
 * 要素の存在確認をし、存在した場合入力要素の値を更新する
 * @param existsElement 要素の存在確認を行う関数
 * @param selector 値をセットする対象セレクタ
 * @param value 更新する値
 */
export const invokeCheckedInput: InvokeCheckedInput = (
  existsElement,
  selector,
  value
) => () => {
  if (!existsElement(selector)) return;
  $(selector).val(value);
};
